import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from "redux";
import DataSlice from './Redux/DataSlice/DataSlice';
import TabsSlice from './Redux/TabsSlice/TabsSlice'
import UserAuthSlice from './Redux/UserAuthSlice/UserAuthSlice'
import PopupSlice from './Redux/PopupSlice/PopupSlice'
import IntakeWorklistSlice from './Redux/IntakeWorklistSlice/IntakeWorklistSlice'

const rootReducer = combineReducers({
    tabs: TabsSlice,
    userAuth: UserAuthSlice,
    dataSlice: DataSlice,
    popup: PopupSlice,
    intakeWorklist: IntakeWorklistSlice,
})

export const store = configureStore({
    reducer: rootReducer,
})
